import { ArrowLeft, ChevronDown, Send, X } from "react-feather";
import styles from "../communication-chat.module.css";
import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import Loader from "../../Loader";
const TenantList = (props) => {
  const { getAccessTokenSilently, user } = useAuth0();
  const [isOpenSendMessagePopUp, setIsOpenSendMessagePopUp] = useState(false);
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [SelectedPropertyId, setSelectedPropertyId] = useState(null);
  const [SelectedPropertyName, setSelectedPropertyName] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [messageValue, setMessageValue] = useState("");
  // const formatPhoneNumber = (phoneNumber) => {
  //   const cleaned = ("" + phoneNumber).replace(/\D/g, "");
  //   const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  //   if (match) {
  //     return "(" + match[1] + ") " + match[2] + "-" + match[3];
  //   }
  //   return cleaned;
  // };

  const getTenantsOfApt = (tnts) => {
    const tenants = props.typeaheadProspectTenantList.filter(
      (t) => t.conversation_id === tnts.conversation_id
    );
    return tenants.length;
  };

  const handleMessagePopupOpen = () => {
    setIsOpenSendMessagePopUp(true);
  };
  const handleMessagePopupClose = () => {
    setIsOpenSendMessagePopUp(false);
  };

  const onSendMessage = async () => {
    if (props.tenantList.length === 0) {
      props?.setSnackbarOpen(true);
      props?.setSnackbarMsg(
        "This property has no tenants to send a message to!"
      );
    }

    let message = messageValue.trim();
    if (!SelectedPropertyId || !message) {
      props?.setSnackbarOpen(true);
      props?.setSnackbarMsg("Please enter a message before sending!");
      return;
    }
    setIsShowLoader(true);
    handleMessagePopupClose();

    const data = {
      property_id: SelectedPropertyId,
      message: message,
    };

    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });
    let url =
      process.env.REACT_APP_APPLICANT_API_URL +
      `v1/send-bulk-message/${SelectedPropertyId}`;

    if (selectedFloor) {
      url =
        process.env.REACT_APP_APPLICANT_API_URL +
        `v1/send-bulk-message/${SelectedPropertyId}?floor=${selectedFloor}`;
    }

    await axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setIsShowLoader(false);
        props?.setSnackbarOpen(true);
        props?.setSnackbarMsg(response.data.message);

        setMessageValue("");
        setSelectedPropertyId(null);
        setSelectedPropertyName(null);
        setSelectedFloor(null);
      })
      .catch((error) => {
        console.log("error", error.data.m);
        props?.setSnackbarOpen(true);
        props?.setSnackbarMsg("Server error");
      });
  };

  return (
    <>
      {props.tenantList.length > 0 &&
        props.tenantList.map((tenant, i) => {
          return (
            <div
              key={tenant.property_id}
              onClick={() => props.toggleAccordionForTenant(tenant.property_id)}
              className={
                props.selectedProperty === tenant.property_id &&
                props.accordionOnForTenant
                  ? `${styles.accordionOn} ${styles.Open}`
                  : `${styles.accordionOn}`
              }
            >
              <p className={`${styles.ListAccoudionTitle}`}>
                <ChevronDown /> {tenant?.propertyName}{" "}
                <span>{tenant?.tenants?.length}</span>
                {/* <button
                  className={`${styles.TenantSendSMSBU}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (tenant.tenants.length === 0) {
                      props?.setSnackbarOpen(true);
                      props?.setSnackbarMsg(
                        "This property has no tenants to send a message to!"
                      );
                      return;
                    }
                    setSelectedPropertyId(tenant?.property_id);
                    setSelectedPropertyName(tenant?.propertyName);
                    handleMessagePopupOpen();
                  }}
                >
                  <Send /> Message
                </button> */}
              </p>
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  console.log(
                    "tenant",
                    tenant,
                    props.typeaheadProspectTenantList
                  );
                  const propertyConversation = props.typeaheadProspectTenantList.find(
                    (p) =>
                      p.type === "Property" &&
                      p?.property_id === tenant?.property_id &&
                      p?.floor_no === 0
                  );

                  if (!propertyConversation) {
                    props?.setSnackbarOpen(true);
                    props?.setSnackbarMsg("No property conversations found");
                  }
                  const propertyInfo = {
                    ...tenant,
                    conversation_id: propertyConversation?.conversation_id,
                  };

                  props.setDetailsForPropertiesChat(propertyInfo);

                  // handleMessagePopupOpen();
                }}
              >
                <div
                  className={
                    false
                      ? `${styles.activeTenant} ${styles.CommuListSec}`
                      : `${styles.CommuListSec}`
                  }
                >
                  <div className={`${styles.CommuListDeSec}`}>
                    <p className={`${styles.ProsTenantList}`}>
                      <span>Tenants</span>
                    </p>
                    <p className={`${styles.ProsTenantListDe}`}>
                      <span>All Tenants</span>
                    </p>
                  </div>
                  {/* <button className={`${styles.TenantSendSMSBUStatic}`}>
                    <Send />
                  </button> */}
                </div>
              </div>
              {tenant?.propertyName?.toLowerCase()?.includes("weston hall") &&
                [1, 2, 3, 4, 5].map((f, i) => {
                  return (
                    <div
                      key={i}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const propertyConversation = props.typeaheadProspectTenantList.find(
                          (p) =>
                            p.type === "Property" &&
                            p?.property_id === tenant?.property_id &&
                            p?.floor_no === f
                        );
                        console.log(
                          "propertyConversation-floor",
                          propertyConversation
                        );
                        if (!propertyConversation) {
                          props?.setSnackbarOpen(true);
                          props?.setSnackbarMsg("No Floor conversations found");
                          // return;
                        }
                        const propertyInfo = {
                          ...tenant,
                          conversation_id:
                            propertyConversation?.conversation_id,
                          floor: f,
                        };

                        props.setDetailsForPropertiesChat(propertyInfo);
                      }}
                    >
                      <div
                        className={
                          false
                            ? `${styles.activeTenant} ${styles.CommuListSec}`
                            : `${styles.CommuListSec}`
                        }
                      >
                        <div className={`${styles.CommuListDeSec}`}>
                          <p className={`${styles.ProsTenantList}`}>
                            <span>Tenants</span>
                          </p>
                          <p className={`${styles.ProsTenantListDe}`}>
                            {f === 1 && <span>1st Floor</span>}
                            {f === 2 && <span>2nd Floor</span>}
                            {f === 3 && <span>3rd Floor</span>}
                            {f === 4 && <span>4th Floor</span>}
                            {f === 5 && <span>5th Floor</span>}
                          </p>
                        </div>
                        {/* <button className={`${styles.TenantSendSMSBUStatic}`}>
                          <Send />
                        </button> */}
                      </div>
                    </div>
                  );
                })}
              {tenant.tenants.length > 0 > 0 &&
                tenant.tenants.map((t) => {
                  return (
                    <div key={t.id}>
                      <div
                        className={
                          t.id === props?.prospectTenantDetails?.id
                            ? `${styles.activeTenant} ${styles.CommuListSec}`
                            : `${styles.CommuListSec}`
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          props.setDetails(t);
                        }}
                      >
                        <div className={`${styles.CommuListDeSec}`}>
                          <p className={`${styles.ProsTenantList}`}>
                            <span>
                              {t?.first_name}&nbsp;{t?.last_name}
                            </span>
                          </p>
                          <p className={`${styles.ProsTenantListDe}`}>
                            <span>{t.apt_no}</span>
                            <span>{getTenantsOfApt(t)} Tenants</span>
                          </p>
                        </div>
                      </div>

                      {/* <p
                        onClick={(e) => {
                          e.stopPropagation();
                          props.setDetails(t);
                        }}
                        className={
                          t.id === props?.prospectTenantDetails?.id
                            ? `${styles.activeTenant} ${styles.ProsTenantList}`
                            : `${styles.ProsTenantList}`
                        }
                      >
                        <span className={`${styles.Unit}`}>{t.apt_no}:</span>
                        <span className={`${styles.Name}`}>
                          {t?.first_name}&nbsp;{t?.last_name}
                        </span>{" "}
                        <span className={`${styles.Phone}`}>
                          {formatPhoneNumber(t.phone)}
                        </span>
                      </p> */}
                    </div>
                  );
                })}
              {tenant.tenants.length === 0 && (
                <div className={`${styles.NoDataSecOnlyText}`}>
                  <img src="/static/img/chatIcon.png" alt="" />
                  <p>No tenant here!</p>
                </div>
              )}
            </div>
          );
        })}

      <Dialog
        open={isOpenSendMessagePopUp}
        onClose={handleMessagePopupClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="alert-dialog-title">
          <button
            className={`${styles.BackAddBU}`}
            onClick={handleMessagePopupClose}
          >
            <ArrowLeft />
          </button>
          Send Message
          <button onClick={handleMessagePopupClose}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <div className={`${styles.AddContactNoRow}`}>
            <div className={`${styles.AddContactNoHalfSec}`}>
              <div className={`${styles.AddContactNoHalfSecRow}`}>
                <div className={`${styles.HalfSecFull} FormGroup`}>
                  <p className={`${styles.DisableFieldSendSMS}`}>
                    {SelectedPropertyName}
                  </p>
                </div>
                {selectedFloor && (
                  <div className={`${styles.HalfSecFull} FormGroup`}>
                    <p className={`${styles.DisableFieldSendSMS}`}>2nd Floor</p>
                  </div>
                )}
                <div className={`${styles.HalfSecFull} FormGroup`}>
                  <p className={`${styles.DisableFieldSendSMS}`}>All Tenant</p>
                </div>
                <div className={`${styles.HalfSecFull} FormGroup`}>
                  <TextField
                    id="outlined-multiline-static"
                    label="Message..."
                    multiline
                    rows={6}
                    onChange={(e) => setMessageValue(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className={`${styles.ButtonSec}`}>
              <button
                onClick={handleMessagePopupClose}
                className="CancelPopupBU"
              >
                Cancel
              </button>
              <button onClick={onSendMessage} className="SubmitPopupBU">
                Send
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {isShowLoader && <Loader />}
    </>
  );
};

export default TenantList;
